import { get } from 'lodash';

export const sortByPositionInArray = (items: any[], ids: string[], key: string = '_id') => {
  return items.sort((a, b) => ids.indexOf(get(a, key)) - ids.indexOf(get(b, key)));
};

export const sortByOrder = (items: any[]) => {
  return items.sort((a, b) => a.order - b.order);
};
